/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectDealer: {
    id: 'MiniProductGrid.MiniProduct.selectDealer',
    defaultMessage: 'Set a location to see availability'
  },
  availability: {
    id: 'MiniProductGrid.MiniProduct.availability',
    defaultMessage:
      'Available {isAvailable, select, true {today} other {in 2-5 Days}}'
  },
  availabilityOverride: {
    id: 'MiniProductGrid.MiniProduct.availability.override',
    defaultMessage: 'Available Next Day Air'
  },
  coreCost: {
    id: 'MiniProductGrid.MiniProduct.coreCost',
    defaultMessage: 'Core Cost:'
  },
  dealerPartNumber: {
    id: 'MiniProductGrid.MiniProduct.dealerPartNumber',
    defaultMessage: 'Dealer #:'
  },
  partNumberMatch: {
    id: 'MiniProductGrid.MiniProduct.partNumberMatch',
    defaultMessage: 'Part # Match'
  },
  partialPartNumberMatch: {
    id: 'MiniProductGrid.MiniProduct.partialPartNumberMatch',
    defaultMessage: 'Partial Part # Match'
  },
  xRefMatch: {
    id: 'MiniProductGrid.MiniProduct.xRefMatch',
    defaultMessage: 'xRef Match'
  },
  partialXRefMatch: {
    id: 'MiniProductGrid.MiniProduct.partialXRefMatch',
    defaultMessage: 'Partial xRef Match'
  },
  dealerPartNumberMatch: {
    id: 'MiniProductGrid.MiniProduct.dealerPartNumberMatch',
    defaultMessage: 'Dealer Part # Match'
  },
  dealerPartialPartNumberMatch: {
    id: 'MiniProductGrid.MiniProduct.dealerPartialPartNumberMatch',
    defaultMessage: 'Dealer Partial Part # Match'
  },
  matched: {
    id: 'MiniProductGrid.MiniProduct.matched',
    defaultMessage: 'Matched by'
  }
});
